// import './selectRole.scss'
import { useLocal } from '@/i18n/LocalContext'
import CommonModal from '../CommonModal/CommonModal'
import { useStore } from '@/store'
import { useEffect, useMemo, useState } from 'react'
import usePlayer from '@/hooks/usePlayer'
import { Handler } from 'mitt'
import { logout } from '@/request/utils'
import appExpose from '@app/expose'
import { closeLoading, loading, toast } from '@/utils'
import { bind } from '@/request'

const emitter = appExpose.emitter

export default function SelectRole() {
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const zoneId = state.login.userInfo.zoneId
  const roleList = state.login.roleList
  const playerType = state.login.userInfo.playerType
  const justBinded = state.login.userInfo.justBinded
  const playerId = state.login.userInfo.playerId
  const playerName = state.login.userInfo.playerName
  const serverName = state.login.userInfo.serverName
  const { logined, isBinded, checked, isCodeBinded } = usePlayer()
  const [currentRole, setCurrentRole] = useState<{
    playerId: string
    playerName: string
    serverId: string
    serverName: string
  } | null>(null)
  const roleConfirmText = useMemo(() => {
    if (!currentRole) return ''

    const currName = `<span>${currentRole.serverName}${currentRole.playerName}</span>`
    return `${$t('请确认是否使用')}${currName}`
  }, [currentRole])

  useEffect(() => {
    const _handle: Handler<CheckPlayerEvent> = (e) => {
      if (!logined) {
        emitter.emit('checkPlayerReturn', false)
        return window.loginApp?.open()
      }

      switch (e.source) {
        case 'account':
          dispatch({
            type: 'setAlertData',
            data: {
              open: true,
              content: `${$t('当前登录角色')}: <span>${
                isBinded ? `${serverName}${playerName}` : $t('请选择角色')
              }</span>`,
              // resolveText: isBinded ? $t('关闭') : $t('角色绑定'),
              resolveText: $t('关闭'),
              rejectText: !window.inSDK ? $t('退出登录') : '',
              onResolve: () => {
                /* if (!isBinded) {
                  window.loginApp?.openRoles()
                } */
              },
              onReject: () => {
                logout($t('确认退出登录？'))
              },
            },
          })
          break

        default:
          break
      }

      if (!isBinded) {
        emitter.emit('checkPlayerReturn', false)
        if (e.source !== 'account') {
          window.loginApp?.openRoles()
        }
        return
      }

      emitter.emit('checkPlayerReturn', true)
    }

    const _cancel = () => {
      emitter.off('checkPlayer', _handle)
    }

    emitter.on('checkPlayer', _handle)

    if (checked === 1 && isBinded) {
      dispatch({
        type: 'setCode',
        data: {
          code: playerId,
        },
      })
      emitter.emit('getBaseData')
    }

    // 绑定角色弹窗
    if (logined && checked === 1 && !isBinded) {
      // window.loginApp?.openRoles()
      return _cancel
    }

    // 若为回归玩家，则自动弹窗绑定邀请码
    // if (isBinded && playerType === 2 && !isCodeBinded && !justBinded) {
    //   openCodeModal()
    // }

    return _cancel
  }, [
    logined,
    checked,
    zoneId,
    isBinded,
    playerType,
    justBinded,
    serverName,
    playerId,
    playerName,
  ])

  // 选择角色
  useEffect(() => {
    const _selectRole: Handler<SelectRoleEvent> = (e) => {
      const { role } = e
      console.log('选择角色 =>', { ...role })

      setCurrentRole({
        playerId: role.playerId,
        playerName: role.nickname,
        serverId: role.serverId,
        serverName: role.serverName,
      })
    }
    emitter.on('selectRole', _selectRole)

    return () => {
      emitter.off('selectRole', _selectRole)
    }
  }, [])
  useEffect(() => {
    if (currentRole == null) return
    console.log('确认角色 =>', currentRole)

    dispatch({
      type: 'setAlertData',
      data: {
        open: true,
        rejectClose: true,
        content: roleConfirmText,
        hint: $t('*角色一旦绑定，活动期间不可更改'),
        onResolve: () => {
          loading()
          bind(currentRole.playerId)
            .then((playerType) => {
              if (!playerType) {
                emitter.emit('selectRoleReturn', false)
                return
              }

              emitter.emit('selectRoleReturn', true)

              dispatch({
                type: 'setPlayer',
                data: {
                  playerType,
                  playerId: currentRole.playerId,
                  playerName: currentRole.playerName,
                  serverId: currentRole.serverId,
                  serverName: currentRole.serverName,
                  isBinded: true,
                },
              })

              setTimeout(() => {
                dispatch({
                  type: 'setAlertData',
                  data: {
                    open: true,
                    showLogoutBtn: true,
                    content: `${$t('当前登录角色')}: ${currentRole.serverName}${
                      currentRole.playerName
                    }`,
                    resolveClose: true,
                    onResolve: () => {
                      if (playerType === 2) {
                        openCodeModal()
                      }
                    },
                  },
                })
              }, 1)
              setTimeout(() => {
                toast($t('绑定成功'), false, 2000)
                setTimeout(() => {
                  if (playerType === 2) {
                    openCodeModal()
                  }
                }, 2000)
              }, 4)
            })
            .finally(closeLoading)
        },
        onReject: () => {
          emitter.emit('selectRoleReturn', false)
        },
      },
    })
  }, [zoneId, currentRole, roleConfirmText])

  const _logout = () => {
    logout()
  }

  // open={selectRoleOpen}
  return (
    <CommonModal open={false} title={$t('角色绑定')} type="select-role">
      {[
        [
          /* isEur ? (<div key="11" className={`region${showAreaList ? ' region--open' : ''}`}>
          <div className="region-field" onClick={toggleAreaList}>
            <span>{!currentAreaName ? $t('请选择大区') : currentAreaName}</span>
            <i className="region-field__arrow"></i>
          </div>
          <div className="region-list">
            <div className="region-item" onClick={() => selectZone(1)}>{$t('美洲')}</div>
            <div className="region-item" onClick={() => selectZone(2)}>{$t('欧洲')}</div>
          </div>
        </div>) : null, */
          <div key="12" className="role">
            <div className="role-field">
              <span
                dangerouslySetInnerHTML={{
                  __html: !currentRole
                    ? $t('请选择角色')
                    : currentRole.serverName + currentRole.playerName,
                }}
              ></span>
              <i className="role-field__arrow"></i>
            </div>
            <div className="role-list">
              {roleList.map((role) => (
                <div
                  key={role.playerId}
                  className="role-item"
                  dangerouslySetInnerHTML={{ __html: role.optionName }}
                ></div>
              ))}
            </div>
          </div>,
          <p
            key="13"
            className="common-modal-text"
            style={{ textAlign: 'center', opacity: !currentRole ? '0' : '1' }}
            dangerouslySetInnerHTML={{ __html: roleConfirmText }}
          ></p>,
          <p key="14" className="common-modal-hint">
            {$t('*角色一旦绑定，活动期间不可更改')}
          </p>,
        ],
        [
          !window.inSDK ? (
            <a
              key="21"
              data-key="logout"
              className="common-modal-reject"
              onClick={_logout}
            >
              <span>{$t('退出登录')}</span>
            </a>
          ) : null,
          <a key="22" className="common-modal-btn">
            <span>{$t('确定')}</span>
          </a>,
        ],
      ]}
    </CommonModal>
  )

  function openCodeModal() {
    dispatch({
      type: 'updateModal',
      data: {
        recallOpen: true,
      },
    })
  }
}
